import "./searchadspage.scss";
import React, { useEffect, useRef, useState } from "react";
import DefaultLayout from "../../layout/defaultLayout";
import { Box, Chip, Snackbar, Alert } from "@mui/material";
import SearchAdsChartContainer from "features/searchads/chartContainer";
import TableContainer from "features/searchads/TableContainer";
import { DatePicker } from "components/DatePicker/index";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLevel,
  updateHotelId,
  updateGroupId,
} from "store/slices/account/accountSlice";
import HotelsFilterMenu from "components/hotelFilterMenu";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import EditCampaignPanel from "features/google-search-ads-campaign/EditCampaignPanel";
import PageTitles from "../../components/PageTitles";
import HoverButton from "../../components/HoverButton";
import qs from 'query-string';
import { updateSegmentList, updateSelectedSegments } from "store/slices/searchAds/searchAds";
import { getDefaultSegments } from "utils/functions/getDefaultSegments";

const SearchAdsPage = () => {
  const searchParams = qs.parse(window.location.search)
  const {pathname, search} = useLocation()
  const {platform,selected_segments} = useSelector((state) => state?.searchAds);
  const hotelId = useSelector((state) => state?.account?.hotel_id);
  const {
        account_id = "",
        "is_account_writable": isAccountWritable,
    } = useSelector((state) => state?.account?.account || {});
    const { level, group_id = [], hotel_id=[], hotelList = [] , groupList = [], can_use_groups: showGroups } = useSelector(state =>state?.account)
  const hotelButtonRef = useRef(null);
  const [openHotelModal, setOpenHotelModal] = useState(false);
  const [selectedHotelOrGroupType, setSelectedHotelOrGroupType] =
    useState("hotels");
  const scrollContainerRef = useRef(null);
  const [isChartCollapsed, setIsChartCollapsed] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPanelOpen, setPanelOpen] = useState(false);
  const [editCampaignId, setEditCampaignId] = useState();
    const [,setCurrentAccountId] = useState(account_id);

  const handleCreateCampaign = () => {
    if (hotel_id?.length ===1) {
      navigate(`/search-ads-campaign/create/${account_id}/${hotelId?.[0]}`);
    } else {
      setToastMessage("Please select one hotel.");
      setToastType("error");
      setShowToast(true);
    }
  };

  const togglePanel = () => {
    setPanelOpen((prev) => !prev);
  };

  useEffect(() => {
      if(account_id){
        setCurrentAccountId(prev => {
          if(prev !== account_id){
            dispatch(updateGroupId([]));
          }
          return account_id;
        })
      } else {
        if (searchParams?.['hotelid']) {
          dispatch(updateLevel("HOTEL"));
          dispatch(updateGroupId([]));
          if (typeof searchParams?.['hotelid'] === "string") {
            dispatch(updateHotelId([Number(searchParams?.['hotelid'])]));
          } else {
            dispatch(updateHotelId(searchParams?.['hotelid'].map((h) => Number(h))));
          }
        }
        if (searchParams?.['groupid']) {
          dispatch(updateHotelId([]));
          dispatch(updateLevel("GROUP"));
          if (typeof searchParams?.['groupid'] === "string") {
            dispatch(updateGroupId([Number(searchParams?.['groupid'])]));
          } else {
            dispatch(updateGroupId(searchParams?.['groupid'].map((h) => Number(h))));
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account_id, hotelList, dispatch, search]);

  useEffect(() => {
    if(!level){
      dispatch(
        updateLevel(selectedHotelOrGroupType === "hotels" ? "HOTEL" : "GROUP")
      );
    }

    if(!searchParams?.['segments']){
      if (searchParams?.['hotelid']) {
        dispatch(updateLevel("HOTEL"));
        if (typeof searchParams?.['hotelid'] === "string") {
          dispatch(updateHotelId([Number(searchParams?.['hotelid'])]));
          dispatch(updateSegmentList(getDefaultSegments([Number(searchParams?.['hotelid'])], "HOTEL")))
        } else {
          dispatch(updateHotelId(searchParams?.['hotelid'].map((h) => Number(h))));
          dispatch(updateSegmentList(getDefaultSegments(searchParams?.['hotelid'].map((h) => Number(h)), "HOTEL")))
        }
      } else if (searchParams?.['groupid']) {
        dispatch(updateLevel("GROUP"));
        if (typeof searchParams?.['groupid'] === "string") {
          dispatch(updateGroupId([Number(searchParams?.['groupid'])]));
          dispatch(updateSegmentList(getDefaultSegments([Number(searchParams?.['groupid'])], "GROUP")))
        } else {
          dispatch(updateGroupId(searchParams?.['groupid'].map((h) => Number(h))));
          dispatch(updateSegmentList(getDefaultSegments(searchParams?.['groupid'].map((h) => Number(h)), "GROUP")))
        }
      }
      dispatch(updateSelectedSegments(null))
    } else {
      dispatch(updateSelectedSegments(typeof searchParams?.['segments']=== 'string' ? [searchParams?.['segments']]: searchParams?.['segments']))
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, search, level]);

  useEffect(() => {
    if(!searchParams?.['hotelid'] && !searchParams?.['groupid'] && !searchParams?.['segments']){
      dispatch(updateSegmentList(getDefaultSegments(level === "GROUP" ? group_id : hotelId, level)))
    }
  },[dispatch,search,hotelId,group_id,level])

  useEffect(() => {
    return () => {
      if(!searchParams?.['segments']) {
        dispatch(updateSelectedSegments(null))
      }
      dispatch(updateLevel(group_id.length ? "GROUP" : "HOTEL"))
    }
  },[dispatch, group_id])

  return (
    <Box className="metasearch">
      <DefaultLayout page={isPanelOpen ? null : "SearchAdsPage"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "18px",
          }}
        >
          <PageTitles pageTitle="Search Ads" pageSubTitle="" />
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                }}
            >
                {isAccountWritable && (
                    <HoverButton text="New Campaign" onClick={handleCreateCampaign}/>
                )}

                <DatePicker />
          </Box>
        </Box>
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "8px",
                paddingInline: "16px",
            }}
        >
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#000000",
                  fontWeight: "400",
                  marginTop: "4px",
                }}
              >
                <div
                  onClick={() => {
                    setOpenHotelModal(true);
                  }}
                  ref={hotelButtonRef}
                >
                  <Chip
                    label={
                      level === "HOTEL" ? hotelId.length === 0
                        ? "Hotels"
                        : hotelId.length === hotelList.length
                          ? "All Hotels"
                        : hotelId.length === 1
                        ? hotelList?.find(
                            (hotel) =>
                              hotel.hotel_id === hotelId?.[0]
                          )?.hotel_name
                        : `${hotelId.length} ${
                             "hotels"
                          } selected`: group_id.length === 0 ? "Groups" : group_id.length === groupList.length ? "All Groups" : group_id.length === 1
                          ? groupList?.find(
                              (group) =>
                                group.id === group_id?.[0]
                            )?.name
                          : `${group_id.length} ${
                               "groups"
                            } selected`
                    }
                    sx={{
                      backgroundColor: "inherit",
                      fontFamily: "inter",
                      fontSize: "12px",
                      fontWeight: "400",
                      marginRight: "4px",
                      height: "26px",
                      minWidth:'120px',
                      //border:hotel_id.length > 0 ? "1px solid #000000" : "1px solid #BAB7B7",
                      border:"1px solid #BAB7B7",
                      ":hover": {
                        cursor: "pointer",
                        border: "1px solid #000000",
                      },
                    }}
                  />
                </div>
                {openHotelModal && (
                  <HotelsFilterMenu
                    allHotels={hotelList?.map((ho) =>
                      hotelId.find((hf) => hf === ho.hotel_id)
                        ? { ...ho, isSelected: true }
                        : { ...ho, isSelected: false }
                    )}
                    showGroups={showGroups}
                    anchorEl={hotelButtonRef.current}
                    open={openHotelModal}
                    allGroups={groupList?.map((ho) =>
                      group_id.includes(ho.id)
                        ? { ...ho, isSelected: true }
                        : { ...ho, isSelected: false }
                    )}
                    isSelectAllRequired
                    onApply={(selected) => {
                        const type = selected?.length ? selected.filter(s => s?.isSelected).some(s => s?.type === "HOTEL") ? "hotels" : "groups" : selectedHotelOrGroupType;
                        dispatch(
                          updateLevel(type === "hotels" ? "HOTEL" : "GROUP")
                        );
                        if(!selected_segments){
                          dispatch(updateSegmentList(getDefaultSegments(selected, type === "hotels" ? "HOTEL" : "GROUP")))
                          dispatch(updateSelectedSegments(null))
                        }
                        if (type === "hotels") {
                          dispatch(
                            updateHotelId(
                              selected.map((item) => item?.["hotel_id"])
                            )
                          );
                          dispatch(updateGroupId([]))
                          delete searchParams?.groupid
                          navigate(`${pathname}?${createSearchParams({...searchParams, hotelid: selected?.map(p => p.hotel_id)})}`)
                        } else {
                          dispatch(
                            updateGroupId(selected.map((item) => item?.["id"]))
                          );
                          dispatch(updateHotelId([]))
                          delete searchParams?.hotelid
                          navigate(`${pathname}?${createSearchParams({...searchParams, groupid: selected?.map(p => p.id)})}`)
                        }
                    }}
                    onClose={() => {
                      setOpenHotelModal(false);
                    }}
                    setSelectedHotelOrGroupType={(type) => {
                      setSelectedHotelOrGroupType(type);
                    }}
                    selectedHotelOrGroupType={level === "HOTEL" ? "hotels" : "groups"}
                  />
                )}
              </div>
            </div>
          </div>
        </Box>
        <Box sx={{}} ref={scrollContainerRef}>
          <div
            style={{
                height: "228px",
              display: isChartCollapsed ? "none" : "block",
            }}
          >
            <SearchAdsChartContainer backgroundColor="transparent" />
          </div>
          <TableContainer
          hotelList={hotelList}
            isChartCollapsed={isChartCollapsed}
            setIsChartCollapsed={setIsChartCollapsed}
            onEditClick={() => {
              if (platform?.length > 1) {
                setToastMessage("Please select single platform");
                setToastType("error");
                setShowToast(true);
              }
            }}
            onEditCampaign={(id) => {
              setEditCampaignId(id);
              setPanelOpen(true);
            }}
          />
        </Box>{" "}
        <EditCampaignPanel
          campaignId={editCampaignId}
          isOpen={isPanelOpen}
          onClose={togglePanel}
        />
      </DefaultLayout>
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showToast}
        autoHideDuration={3000}
        onClose={() => {
          setShowToast(false);
        }}
      >
        <Alert severity={toastType} variant="filled" sx={{ width: "100%" }}>
          {toastMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default SearchAdsPage;
